import { render, staticRenderFns } from "./ApplySetting.vue?vue&type=template&id=22c4ea9c&scoped=true"
import script from "./ApplySetting.vue?vue&type=script&lang=ts"
export * from "./ApplySetting.vue?vue&type=script&lang=ts"
import style0 from "./ApplySetting.vue?vue&type=style&index=0&id=22c4ea9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c4ea9c",
  null
  
)

export default component.exports